import CartUtils from '@order/CartUtils'
import usePayments from '@order/hooks/usePayments'
import { trpc } from 'api'
import useSession from 'hooks/useSession'
import { useEffect, useMemo } from 'react'

const useRefreshCustomer = () => {
  const setCustomer = useSession((s) => s.setCustomer)

  const refreshCustomer = trpc.customer.refresh.useMutation({
    onSuccess: setCustomer,
  })

  return refreshCustomer
}

export const usePaymentSuccessRefresh = () => {
  const payments = usePayments((s) => s.payments)
  const customer = useSession((s) => s.customer)

  const paidOrdersCount = useMemo(() => {
    return Object.values(payments).filter((p) =>
      CartUtils.payments.isFinalStatus(p)
    ).length
  }, [payments])

  const refresh = useRefreshCustomer()

  useEffect(() => {
    if (paidOrdersCount === 0 || !customer) {
      return
    }
    refresh.mutate()
  }, [paidOrdersCount, refresh.mutate])
}

export default useRefreshCustomer
